module.exports = [
	{
		"featureType" : "landscape",
		"elementType" : "all",
		"stylers" : [
			{"color" : "#f2f2f2"},
			{"lightness" : "10"}
		]
	}, {
		"featureType" : "landscape",
		"elementType" : "labels",
		"stylers" : [ {
			"visibility" : "simplified"
		} ]
	}, {
		"featureType" : "water",
		"elementType" : "geometry",
		"stylers" : [
			{"color" : "#adcdd9"}
		]
	}, {
		"featureType" : "landscape.natural",
		"elementType" : "geometry",
		"stylers" : [
			{"saturation" : "-20"},
			{"lightness" : "20"}
		]
	}, {
		"featureType" : "poi",
		"elementType" : "geometry",
		"stylers" : [
			{"saturation" : "-20"},
			{"lightness" : "20"}
		]
	}, {
		"featureType" : "road",
		"elementType" : "geometry",
		"stylers" : [
			{"saturation" : "70"}
		]
	}
	
	
	
	/*
	{
		"featureType" : "administrative",
		"elementType" : "all",
		"stylers" : [ {
			"visibility" : "simplified"
		}, {
			"color" : "#b8c0a2"
		} ]
	}, {
		"featureType" : "administrative",
		"elementType" : "labels",
		"stylers" : [ {
			"visibility" : "simplified"
		}, {
			"color" : "#393939"
		} ]
	}, {
		"featureType" : "administrative",
		"elementType" : "labels.text.fill",
		"stylers" : [ {
			"visibility" : "on"
		} ]
	}, {
		"featureType" : "administrative",
		"elementType" : "labels.text.stroke",
		"stylers" : [ {
			"visibility" : "on"
		}, {
			"color" : "#ffffff"
		} ]
	}, {
		"featureType" : "landscape",
		"elementType" : "all",
		"stylers" : [ {
			"color" : "#e7e2dd"
		} ]
	}, {
		"featureType" : "landscape",
		"elementType" : "labels",
		"stylers" : [ {
			"visibility" : "simplified"
		} ]
	}, {
		"featureType" : "landscape.natural",
		"elementType" : "all",
		"stylers" : [ {
			"color" : "#c5ceae"
		} ]
	}, {
		"featureType" : "poi",
		"elementType" : "all",
		"stylers" : [ {
			"visibility" : "simplified"
		}, {
			"color" : "#d4dec4"
		} ]
	}, {
		"featureType" : "poi",
		"elementType" : "labels",
		"stylers" : [ {
			"visibility" : "off"
		}, {
			"color" : "#868383"
		} ]
	}, {
		"featureType" : "road.highway",
		"elementType" : "geometry",
		"stylers" : [ {
			"color" : "#ffffff"
		}, {
			"visibility" : "on"
		} ]
	}, {
		"featureType" : "road.highway",
		"elementType" : "geometry.stroke",
		"stylers" : [ {
			"visibility" : "on"
		}, {
			"color" : "#d0d0d0"
		} ]
	}, {
		"featureType" : "road.highway",
		"elementType" : "labels.icon",
		"stylers" : [ {
			"saturation" : "-39"
		}, {
			"lightness" : "7"
		} ]
	}, {
		"featureType" : "water",
		"elementType" : "labels",
		"stylers" : [ {
			"visibility" : "simplified"
		}, {
			"color" : "#ffffff"
		} ]
	}
	*/
];